// ================== DATATABLE =====================
window.getDatatableTexts = function () {
	return {
		sProcessing: polyglot.t("global.datatable.processing"),
		sLengthMenu: polyglot.t("global.datatable.lenth_menu"),
		sZeroRecords: polyglot.t("global.datatable.zero_records"),
		sEmptyTable: polyglot.t("global.datatable.empty_table"),
		sInfo: polyglot.t("global.datatable.info"),
		sInfoEmpty: polyglot.t("global.datatable.info_empty"),
		sInfoFiltered: polyglot.t("global.datatable.info_filtered"),
		sLoadingRecords: polyglot.t("global.datatable.loading_records"),
		sSortAscending: polyglot.t("global.datatable.sort_ascending"),
		sSortDescending: polyglot.t("global.datatable.sort_descending")
	};
}

//window.getLiteralPerfil = function(idPerfil)  (1..12)
window.getProfileLiteral = function (id) {
	return polyglot.t("global.profiles.profile_" + id);
}

//window.getLiteralEventType = function(idEventType) (0..5)
window.getEventTypeLiteral = function (id) {
	return polyglot.t("global.event_types.event_type_" + id);
}

//window.getLiteralHallType = function(idHallType) (0..3)
window.getHallTypeLiteral = function (id) {
	return polyglot.t("global.hall_types.hall_type_" + id);
}

//window.getLiteralEstadosButaca = function(idFormaPago) (-1, 0..3, 10..12, 50..52, 100..102
window.getSeatStatusLiteral = function (id) {
	return polyglot.t("global.seat_statuses.seat_status_" + id);
}

//window.getLiteralEstadoPago = function(idEstadoPago) (0..3, 10..13)
window.getPaymentStatusLiteral = function (id) {
	return polyglot.t("global.payment_status.payment_status_" + id);
}

//window.getLiteralFormaPago = function(idFormaPago) (1..24)
window.getPaymentMethodLiteral = function (id) {
	return polyglot.t("global.payment_methods.payment_method_" + id);
}


window.getPaymentMethodFieldLiteral = function (paymentMethodId, fieldName, defaultValue) {
	return polyglot.t("global.payment_methods.setup.payment_method_" + paymentMethodId + "." + fieldName, {
		_: defaultValue
	});
}

//función para el select de tipo de método de pago
window.getPaymentMethodSelectOptions = function (paymentMethodId, fieldName, defaultValue) {
	let htmlSelect = [];
	let text, label;
	let iCont = 1;

	text = polyglot.t("global.payment_methods.setup.payment_method_" + paymentMethodId + "." + fieldName + ".res_value_" + iCont, {
		_: defaultValue
	});

	while (text != null && text != "null") {
		//iCont++;
		text = polyglot.t("global.payment_methods.setup.payment_method_" + paymentMethodId + "." + fieldName + ".res_value_" + iCont, {
			_: defaultValue
		});
		label = polyglot.t("global.payment_methods.setup.payment_method_" + paymentMethodId + "." + fieldName + ".res_label_" + iCont++, {
			_: defaultValue
		});
		if (text != null && text != "null") {
			htmlSelect.push({ value: text, label: label });
		}
	}
	return htmlSelect;
}

//window.getFriendlyUrlSector = function(idSector) (1..5)
window.getFriendlyUrlSectorLiteral = function (id) {
	return polyglot.t("global.friendly_url_sectors.friendly_url_sector_" + id);
}

window.getLoyaltyPointsLiteral = function (valor) {
	return polyglot.t("(amount)_points_abbreviation", { points: valor });
}

window.getProductTypeLiteral = function (id) {
	return polyglot.t("global.product_types.product_type_" + id);
}

window.getPriceTypeLiteral = function (id) {
	return polyglot.t("global.price_types.price_type_" + id);
}

window.getPriceTypeDescription = function (id) {
	return polyglot.t("global.price_types.price_type_desc_" + id);
}
